import React, { useState } from "react";
import Form from 'react-bootstrap/Form';
import { IoClose } from "react-icons/io5";
import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { API_URL } from "../../Api/config";

function SupportPopup(props) {

    console.log("props", props)

    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [descripation, setDescripation] = useState('');
    const [serverSideError, setServerSideError] = useState(null);

    const [apicall, setApicall] = useState(false);
    const [validated, setValidated] = useState(false);
    const handleSubmit = (event) => {
        setApicall(true);
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setApicall(false);
        } else {
            event.preventDefault();

            axios.post(API_URL+'contact/submit', {
                firstName: firstname,
                lastName: lastname,
                phoneNumber: phone,
                email: email,
                description: descripation,
                subject: props.subject
            }
                , {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    console.log(response);
                    setFirstname('');
                    setLastname('');
                    setPhone('');
                    setEmail('');
                    setDescripation('');
                    setValidated(false);
                    setServerSideError(null);
                    props.onHideForm(false);
                    props.onShowForm(true);

                    // do something with response, like setting a success message state
                })
                .catch(error => {
                    console.log("error",error);
                    setApicall(false);
                    props.onHideForm(true);
                    props.onShowForm(false);
                    setServerSideError(error.response.data);
                    // handle the error
                })
                // .finally(() => {
                //     setApicall(false);
                //     props.onHideForm(false);
                //     props.onShowForm(true);
                // });
        }

        setValidated(true);
    };


   

    return (
        <>

            


            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <div className="row gx-2">
                    <div className="col-md-6 form-group" controlid="validationCustom01">
                        <input type="text" name="f-name" className="form-control" value={firstname} onChange={(e) => setFirstname(e.target.value)} placeholder="First name" required />
                        <Form.Control.Feedback type="invalid">
                            Please enter a first name.
                        </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 form-group" controlid="validationCustom02">
                        <input type="text" name="l-name" className="form-control" value={lastname} onChange={(e) => setLastname(e.target.value)} placeholder="Last name" required />
                        <Form.Control.Feedback type="invalid">
                            Please enter a last name.
                        </Form.Control.Feedback>
                    </div>
                    <div className="col-md-12 form-group" controlid="validationCustom03">
                        <input type="tel" name="name" pattern="[0-9]{8,}" value={phone} title="Please enter a 8-digit phone number." onChange={(e) => setPhone(e.target.value)} className="form-control" placeholder="Phone" required />
                        <Form.Control.Feedback type="invalid">
                            Please enter a 8-digit phone number.
                        </Form.Control.Feedback>
                        {serverSideError && (serverSideError.data).map((error, index) => (
                            error.field === 'phone_number' ? (
                                <div className="text-danger" key={index}>{error.detail}</div>
                            ) : null
                        ))}
                    </div>
                    <div className="col-md-12 form-group" controlid="validationCustom04">
                        <input type="email" className="form-control" name="email" value={email} placeholder="Email" onChange={(e) => setEmail(e.target.value)} required />
                        <Form.Control.Feedback type="invalid">
                            Please choose a email.
                        </Form.Control.Feedback>
                        {serverSideError && (serverSideError.data).map((error, index) => (
                            error.field === 'email' ? (
                                <div className="text-danger" key={index}>{error.detail}</div>
                            ) : null
                        ))}
                    </div>
                    <div className="col-md-12 form-group">
                        <textarea className="form-control" name="message" value={descripation} placeholder="Let us now what you need!" rows={5} onChange={(e) => setDescripation(e.target.value)} required></textarea>
                    </div>
                    <div className="col-md-12 text-center">
                        <button className="btn btn-dark btn-block form-btn" type="submit">
                            {
                                apicall ? <Spinner animation="border" className="border-white" /> : <span>Send us a message</span>
                            }
                        </button>
                    </div>
                </div>
            </Form>
        </>
    );
}

export default SupportPopup;